import PasswordSVG from "@design-system/ui-icons/vanilla/Password"
import { createIcon } from "../createIcon"

export const PasswordIcon = createIcon(PasswordSVG)
